import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ConfirmDialog" */'@modals/partials/ConfirmDialog'));
